import { FLAGS } from "../constants";

const {
  SHOW_APPLICATIONS,
  SHOW_DATA_MODELS,
  SHOW_USERS,
  SHOW_APPLICATION_SETTINGS,
  SHOW_COLLECTIONS,
  SHOW_ENDPOINTS,
  SHOW_SERVICES,
  SHOW_BACKGROUND_TASKS,
  SHOW_API_DOCS,
  SHOW_DATA_MODEL_SETTINGS,
  SHOW_DATA,
  SHOW_INTEGRATIONS,
  SHOW_USER_ROLES,
  SHOW_MULESOFT_GENERATED_WEBHOOKS,
  SHOW_APP_DATA_MODAL,
} = FLAGS;

const getUpdatedFeatureFlags = (featuresObj, userId, domain) => {
  const updatedFeatureFlags = Object.entries(featuresObj).reduce(
    (updatedFeatureFlags, [featureName, featureValue]) => {
      const { showAll, hide, show } = featureValue;
      updatedFeatureFlags[featureName] = showAll
        ? !hide.find((val) => val === userId || val === domain)
        : show.find((val) => val === userId || val === domain);
      return updatedFeatureFlags;
    },
    {}
  );

  if (!updatedFeatureFlags[SHOW_APPLICATIONS]) {
    updatedFeatureFlags[SHOW_APP_DATA_MODAL] = false;
    updatedFeatureFlags[SHOW_APPLICATION_SETTINGS] = false;
  } else if (!updatedFeatureFlags[SHOW_DATA_MODELS]) {
    updatedFeatureFlags[SHOW_COLLECTIONS] = false;
    updatedFeatureFlags[SHOW_ENDPOINTS] = false;
    updatedFeatureFlags[SHOW_SERVICES] = false;
    updatedFeatureFlags[SHOW_BACKGROUND_TASKS] = false;
    updatedFeatureFlags[SHOW_API_DOCS] = false;
    updatedFeatureFlags[SHOW_DATA] = false;
    updatedFeatureFlags[SHOW_DATA_MODEL_SETTINGS] = false;
  } else if (!updatedFeatureFlags[SHOW_USERS])
    updatedFeatureFlags[SHOW_USER_ROLES] = false;
  else if (!updatedFeatureFlags[SHOW_INTEGRATIONS])
    updatedFeatureFlags[SHOW_MULESOFT_GENERATED_WEBHOOKS] = false;

  return updatedFeatureFlags;
};

export default getUpdatedFeatureFlags;
